// JsFromRoutes CacheKey f482fdd77cadd0d93c17c81a316d37bb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  update: /* #__PURE__ */ definePathHelper('patch', '/consumer/private_user_profile'),
}
